module.exports = __webpack_public_path__ + "static/service-consultancy-1444ed65ce28e3fe43f9c33ac4c0f5b8.jpg";